export default __webpack_public_path__ + "static/logo11-657d8b5d6b9a6c8035d20e6dd089938c.png";